<template>
  <div id="selector-group">
    <div class="list">
      <div class="item" v-for="(group, index) in list" @click="select(group)" :class="{ selected: group.id == $route.params.group }">
        {{'miclive.standing.group' | translate}} {{ group.name }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Groups",
    props: {
      list: Array,
      category_id: String
    },
    data() {
      return {};
    },
    computed: {},
    methods: {
      load() {
          if( typeof this.$route.params.group === 'undefined' && typeof this.list[0] !== 'undefined' ){
            console.log( this.list[0] )
            this.select( this.list[0] )
          }
      },
      select(group) {
       var self = this;
       this.$overlay.loading();
        this.$router.push({
          name: "standing_group",
          params: {
            group: group.id,
          }
        });
      }
    },
    created() {
      this.load();
    },
    watch: {
      // call again the method if the route changes
      $route: "load"
    },
  };

</script>

<style lang="scss" scoped>
  .list {
    width: 100%;

    .item {
      padding: 10px 25px;
      margin-bottom: 10px;
      text-align: center;
      display: inline-block;
      cursor: pointer;

      &.selected {
        border-bottom: 5px solid $main-color !important;
      }

      &:hover {
        border-bottom: 5px solid #ddd;
      }
    }
  }

  @media only screen and (max-width: 600px) {
    .list {
      .item {
        width: 25%;
        padding: 2px 5px;
      }
    }
  }

</style>
